import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

export default function ProviderIdentity({ provider, compact = false }) {
  const isPro = provider.tier === 'pro';
  const showLogo = isPro && provider.provider_logo;
  const showDescription = isPro && provider.description && !compact;

  return (
    <div className="flex items-center gap-3 min-w-0">
      {showLogo ? (
        <img
          src={provider.provider_logo}
          alt={`${provider.provider_name} Logo`}
          className="w-8 h-8 rounded-lg object-contain bg-white"
          loading="lazy"
        />
      ) : (
        <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center text-xs font-bold text-slate-500">
          {provider.provider_name.charAt(0)}
        </div>
      )}
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-sm text-slate-900 truncate">{provider.provider_name}</span>
          {isPro && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Badge className="bg-sky-50 text-sky-700 border-sky-200 text-[10px]" data-testid="pro-badge">
                    Pro
                  </Badge>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-xs">Verifizierter Anbieter – präsentiert sich hier selbst</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        {showDescription && (
          <p className="text-xs text-muted-foreground truncate max-w-[220px]">{provider.description}</p>
        )}
      </div>
    </div>
  );
}

export function ProviderLockLink({ className = '' }) {
  return (
    <Link
      to="/fuer-provider"
      className={`text-[10px] text-slate-400 hover:text-sky-600 transition-colors ${className}`}
      data-testid="provider-lock-link"
    >
      Anbieter? Werde Pro ›
    </Link>
  );
}
